// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import Tdg_CompanyDetailModel from '../../model/tdg-company-detail-model';
import Tdg_CompanyDetailDTO from '../dto/tdg-company-detail-dto';
import dtoSchema from '../schemas/tdg-company-detail-schema';
import ResourceLinkModel from '../../model/resource-link-model';
import Tdg_AddressModel from '../../model/tdg-address-model';
import Tdg_ContactDetailsModel from '../../model/tdg-contact-details-model';
import Tdg_ProfessionModel from '../../model/tdg-profession-model';

export default abstract class Tdg_CompanyDetailModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<Tdg_CompanyDetailDTO>) {
    super();
    if (data) {
      this.id = data.id;
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.creatorId = data.creatorId;
      this.creatorName = data.creatorName ?? undefined;
      this.created = data.created;
      this.modifierId = data.modifierId ?? undefined;
      this.modifierName = data.modifierName ?? undefined;
      this.modified = data.modified ?? undefined;
      this.companyName = data.companyName ?? undefined;
      this.companyAddress = data.companyAddress ? Tdg_AddressModel.toModel(data.companyAddress) : undefined;
      this.companyContactDetails = data.companyContactDetails ? Tdg_ContactDetailsModel.toModel(data.companyContactDetails) : undefined;
      this.companyLogo = data.companyLogo ?? undefined;
      this.companyProfession = data.companyProfession?.map((i) => Tdg_ProfessionModel.toModel(i)) ?? [];
      this.companyApprenticeshipsCount = data.companyApprenticeshipsCount ?? undefined;
      this.companyDescription = data.companyDescription ?? undefined;
      this.organisationName = data.organisationName ?? undefined;
      this.organisationLogo = data.organisationLogo ?? undefined;
      this.organisationContactDetails = data.organisationContactDetails ? Tdg_ContactDetailsModel.toModel(data.organisationContactDetails) : undefined;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;
  /**
  */
  links?: ResourceLinkModel[];
  /**
  * @type {int64}
  */
  creatorId?: number;
  /**
  */
  creatorName?: string;
  /**
  * @type {date-time}
  */
  created?: string;
  /**
  * @type {int64}
  */
  modifierId?: number;
  /**
  */
  modifierName?: string;
  /**
  * @type {date-time}
  */
  modified?: string;
  /**
  */
  companyName?: string;
  /**
  */
  companyAddress?: Tdg_AddressModel;
  /**
  */
  companyContactDetails?: Tdg_ContactDetailsModel;
  /**
  */
  companyLogo?: string;
  /**
  */
  companyProfession?: Tdg_ProfessionModel[];
  /**
  * @type {int32}
  */
  companyApprenticeshipsCount?: number;
  /**
  */
  companyDescription?: string;
  /**
  */
  organisationName?: string;
  /**
  */
  organisationLogo?: string;
  /**
  */
  organisationContactDetails?: Tdg_ContactDetailsModel;

  static toModel(dto: DeepPartial<Tdg_CompanyDetailDTO>): Tdg_CompanyDetailModel;
  static toModel(dto: DeepPartial<Tdg_CompanyDetailDTO> | undefined | null): Tdg_CompanyDetailModel | undefined;
  static toModel(dto: DeepPartial<Tdg_CompanyDetailDTO> | undefined | null): Tdg_CompanyDetailModel | undefined {
    return dto ? new Tdg_CompanyDetailModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<Tdg_CompanyDetailModel> | Tdg_CompanyDetailModel): Tdg_CompanyDetailDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
      links: unwrapped.links,
      creatorId: unwrapped.creatorId,
      creatorName: unwrapped.creatorName,
      created: unwrapped.created,
      modifierId: unwrapped.modifierId,
      modifierName: unwrapped.modifierName,
      modified: unwrapped.modified,
      companyName: unwrapped.companyName,
      companyAddress: unwrapped.companyAddress,
      companyContactDetails: unwrapped.companyContactDetails,
      companyLogo: unwrapped.companyLogo,
      companyProfession: unwrapped.companyProfession,
      companyApprenticeshipsCount: unwrapped.companyApprenticeshipsCount,
      companyDescription: unwrapped.companyDescription,
      organisationName: unwrapped.organisationName,
      organisationLogo: unwrapped.organisationLogo,
      organisationContactDetails: unwrapped.organisationContactDetails,
    } as Tdg_CompanyDetailDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for Tdg_CompanyDetailModel, can not map to Tdg_CompanyDetailDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
